import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { SubRegion } from "@app/shared/classes/subRegion";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";
import { Status } from "@app/shared/enums";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";

export enum CoachingFieldName {
  title = "title",
  coachingResult = "coachingResult",
  mentorName = "mentorName",
  driverName = "driverName",
  coachingTime = "coachingTime",
  attachment = "attachment",
  attachmentVisibletoDriver = "attachmentVisibletoDriver",
  emIncidentNumber = "emIncidentNumber",
  driver3PL = "driver3PL",
  status = "status",
  driver3PLflag = "driver3PLflag",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpiTime = "kpiTime",

  errorMessage = "errorMessage",
  coaching_Id = "coaching_Id",
  mentorId = "mentorId",
  fullName = "fullName"
};

enum FieldLabel {
  TITLE = "ml_144059",
  COACHING_RESULT = "ml_151201",
  MENTOR = "ml_144014",
  MENTEE = "ml_144060",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  DATE = "ml_143958",
  ATTACHMENT = "ml_144011",
  ATTACHMENT_VISABLE_TO_DRIVER = "ml_151202",
  EM_INCIDENT_NUMBER = "ml_144061",
  THIRD_PARTY_DRIVER_ID = "ml_144062",
  IS_DELETED = "ml_144063",
  DRIVER_3PL_FLAG = "ml_153258",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  MENTOR_APEX_ID = "ml_144064",
  MENTOR_NAME = "ml_144065",
  MENTEE_APEX_ID = "ml_144067",
  MENTEE_NAME = "ml_144066",
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.TITLE,
    name: CoachingFieldName.title,
    sort: true
  },
  {
    text: FieldLabel.COACHING_RESULT,
    name: CoachingFieldName.coachingResult,
    sort: true
  },
  {
    text: FieldLabel.MENTOR,
    name: CoachingFieldName.mentorName,
    sort: true
  },
  {
    text: FieldLabel.MENTEE,
    name: CoachingFieldName.driverName,
    sort: true,
    sortFieldName: CoachingFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: CoachingFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: CoachingFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: CoachingFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: CoachingFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.DATE,
    name: CoachingFieldName.coachingTime,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.ATTACHMENT,
    name: CoachingFieldName.attachment,
    sort: false,
  },
  {
    text: FieldLabel.ATTACHMENT_VISABLE_TO_DRIVER,
    name: CoachingFieldName.attachmentVisibletoDriver,
    sort: true,
  },
  {
    text: FieldLabel.EM_INCIDENT_NUMBER,
    name: CoachingFieldName.emIncidentNumber,
    sort: true,
  },
  {
    text: FieldLabel.THIRD_PARTY_DRIVER_ID,
    name: CoachingFieldName.driver3PL,
    sort: true,
  },
  {
    text: FieldLabel.IS_DELETED,
    name: CoachingFieldName.status,
    sort: true,
  },
  {
    text: FieldLabel.CREATED_BY,
    name: CoachingFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: CoachingFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: CoachingFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: CoachingFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

const CoachingSearchByList: SearchByItem[] = [
  { searchBy: CoachingFieldName.title, searchByLabel: FieldLabel.TITLE },
  { searchBy: CoachingFieldName.mentorId, searchByLabel: FieldLabel.MENTOR_APEX_ID },
  { searchBy: CoachingFieldName.mentorName, searchByLabel: FieldLabel.MENTOR_NAME },
  { searchBy: CoachingFieldName.apexId, searchByLabel: FieldLabel.MENTEE_APEX_ID },
  { searchBy: CoachingFieldName.driverName, searchByLabel: FieldLabel.MENTEE_NAME },
  { searchBy: CoachingFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: CoachingFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: CoachingFieldName.coachingTime, searchByLabel: FieldLabel.DATE, searchByType: smartSearchType.dateRangeSelct },
  { searchBy: CoachingFieldName.emIncidentNumber, searchByLabel: FieldLabel.EM_INCIDENT_NUMBER },
  { searchBy: CoachingFieldName.driver3PL, searchByLabel: FieldLabel.THIRD_PARTY_DRIVER_ID },
  {
    searchBy: CoachingFieldName.status, searchByLabel: FieldLabel.IS_DELETED, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: Status.INACTIVE, label: "ml_143931" }, { value: Status.ACTIVE, label: "ml_143932" }]
  },
  {
    searchBy: CoachingFieldName.driver3PLflag, searchByLabel: FieldLabel.DRIVER_3PL_FLAG, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: true, label: "ml_143931" }, { value: false, label: "ml_143932" }]
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetCoachingSearchByList =  ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = CoachingSearchByList.slice();
  result[5].searchDropDownValue = terminals;
  result[6].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}
